import React from 'react';
import { QRCodeSVG } from 'qrcode.react';
import './GameStatus.css';

function GameStatus({ gameState, playerId, isHost, onStartGame }) {
  const gameUrl = `${window.location.origin}/${gameState.gameCode}`;
  const player = gameState.players[playerId];
  const opponentId = isHost ? gameState.guest : gameState.host;
  const opponent = opponentId ? gameState.players[opponentId] : null;
  const isComputerGame = gameState.isComputerGame;
  const opponentName = isComputerGame ? 'Computer' : 'Opponent';

  console.log('GameStatus Debug:', {
    playerId,
    isHost,
    host: gameState.host,
    guest: gameState.guest,
    opponentId,
    hasOpponent: !!opponent,
    phase: gameState.phase,
    isComputerGame
  });

  if (gameState.phase === 'waiting') {
    const hasGuest = gameState.guest !== null && gameState.guest !== undefined;
    console.log('Checking guest presence:', { guest: gameState.guest, hasGuest });

    // Computer games skip waiting for opponent - show ready to start
    if (isComputerGame) {
      return (
        <div className="game-status waiting">
          <h2>Playing vs Computer</h2>
          <div>
            <p>Ready to start! The computer opponent is waiting.</p>
            {isHost && (
              <button onClick={onStartGame} className="btn-primary">
                Start Game
              </button>
            )}
          </div>
        </div>
      );
    }

    return (
      <div className="game-status waiting">
        <h2>Waiting for Players</h2>
        {!hasGuest ? (
          <div className="waiting-content">
            <p>Share this game code with your opponent:</p>
            <div className="game-code-display">{gameState.gameCode}</div>
            <div className="qr-section">
              <p>Or scan this QR code:</p>
              <div className="qr-code-container">
                <QRCodeSVG
                  value={gameUrl}
                  size={160}
                  bgColor="#ffffff"
                  fgColor="#000080"
                  level="M"
                />
              </div>
            </div>
            <p className="waiting-message">Waiting for opponent to join...</p>
          </div>
        ) : (
          <div>
            <p>Both players connected!</p>
            {isHost && (
              <button onClick={onStartGame} className="btn-primary">
                Start Game
              </button>
            )}
            {!isHost && <p>Waiting for host to start the game...</p>}
          </div>
        )}
      </div>
    );
  }

  if (gameState.phase === 'placement') {
    return (
      <div className="game-status placement">
        <div className="status-grid">
          <div className="status-item">
            <span className="label">Your Ships:</span>
            <span className="value">{Object.keys(player.ships).length} / 5</span>
          </div>
          {opponent && (
            <div className="status-item">
              <span className="label">{opponentName} Ready:</span>
              <span className="value">{opponent.ready ? 'Yes' : 'No'}</span>
            </div>
          )}
        </div>
      </div>
    );
  }

  if (gameState.phase === 'battle') {
    const isYourTurn = gameState.currentTurn === playerId;

    return (
      <div className="game-status battle">
        <div className={`turn-indicator ${isYourTurn ? 'your-turn' : 'opponent-turn'}`}>
          {isYourTurn ? '🎯 Your Turn' : `⏳ ${opponentName}'s Turn`}
        </div>
        <div className="battle-stats">
          <div className="stat">
            <span className="label">Your Hits:</span>
            <span className="value">{player.hits.length}</span>
          </div>
          <div className="stat">
            <span className="label">Your Attacks:</span>
            <span className="value">{player.attacks.length}</span>
          </div>
          {opponent && (
            <>
              <div className="stat">
                <span className="label">{opponentName} Hits:</span>
                <span className="value">{opponent.hits.length}</span>
              </div>
              <div className="stat">
                <span className="label">{opponentName} Attacks:</span>
                <span className="value">{opponent.attacks.length}</span>
              </div>
            </>
          )}
        </div>
      </div>
    );
  }

  if (gameState.phase === 'finished') {
    const isWinner = gameState.winner === playerId;
    const defeatMessage = isComputerGame
      ? 'The computer sank all your ships!'
      : 'All your ships were sunk!';

    return (
      <div className="game-status finished">
        <div className={`game-over ${isWinner ? 'victory' : 'defeat'}`}>
          <h2>{isWinner ? '🎉 Victory!' : '😢 Defeat'}</h2>
          <p>{isWinner ? `You sank all ${opponentName.toLowerCase()} ships!` : defeatMessage}</p>
        </div>
      </div>
    );
  }

  return null;
}

export default GameStatus;